// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { useBlogCategoryArticlesDataView } from "@store/Framework/Store/Data/BlogCategory/BlogCategoryHooks";
import { useBlogCategoryArticlesParameter } from "@store/Framework/Store/Starter/Pages/BlogCategory/BlogCategoryHooks";
import updateSearchFields from "@store/Framework/Store/Starter/Pages/BlogCategory/Handlers/UpdateSearchFields";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import React, { FC } from "react";

export interface BlogCategoryArticlesListPaginationPresentationProps
    extends ExpandStyles<BlogCategoryArticlesListPaginationStyles> {}

export interface BlogCategoryArticlesListPaginationProps extends BlogCategoryArticlesListPaginationPresentationProps {}

export interface BlogCategoryArticlesListPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const blogCategoryArticlesListPaginationStyles: BlogCategoryArticlesListPaginationStyles = {};

const BlogCategoryArticlesListPagination: FC<BlogCategoryArticlesListPaginationProps> = ({
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(blogCategoryArticlesListPaginationStyles, extendedStyles, overridedStyles);
    const { isInShell } = useShellContext();
    const dispatch = useAppDispatch();
    const blogCategoryArticlesParameter = useBlogCategoryArticlesParameter();
    const baseBlogArticlesDataView = useBlogCategoryArticlesDataView(isInShell);
    const blogArticlesDataView = usePersistentDataView(baseBlogArticlesDataView);

    if (!blogArticlesDataView.value || !blogArticlesDataView.pagination) {
        return null;
    }

    const pagination = blogArticlesDataView.pagination;

    const changePage = (newPageIndex: number) => {
        dispatch(updateSearchFields({ ...blogCategoryArticlesParameter, page: newPageIndex }));
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        dispatch(updateSearchFields({ ...blogCategoryArticlesParameter, page: 1, pageSize: newPageSize }));
    };

    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={pagination.prevPageUri}
            nextPage={pagination.nextPageUri}
        />
    );
};

export default BlogCategoryArticlesListPagination;
